export enum CardButtonsStatusEnum {
	masterRecord,
	copyRecord
}
